import ENDPOINTS from 'constants/endpoints';
import axios from 'axios';
import { BPOINT, breakPoints } from 'constants/breakpoints';
import { logger, Analytics } from 'packages';
import { getReturnUrl } from 'utils/login';
import itemActions from './items';

const actionTypes = {
    OPEN_QUICK_VIEW: 'UI/OPEN_QUICK_VIEW',
    CLOSE_QUICK_VIEW: 'UI/CLOSE_QUICK_VIEW',
    OPEN_VIDEO_MODAL: 'UI/OPEN_VIDEO_MODAL',
    CLOSE_VIDEO_MODAL: 'UI/CLOSE_VIDEO_MODAL',
    OPEN_MEGA_MENU: 'UI/OPEN_MEGA_MENU',
    CLOSE_MEGA_MENU: 'UI/CLOSE_MEGA_MENU',
    OPEN_SIGN_IN_MODAL: 'UI/OPEN_SIGN_IN_MODAL',
    CLOSE_SIGN_IN_MODAL: 'UI/CLOSE_SIGN_IN_MODAL',
    OPEN_MESSAGING_MODAL: 'UI/OPEN_MESSAGING_MODAL',
    CLOSE_MESSAGING_MODAL: 'UI/CLOSE_MESSAGING_MODAL',
    ITEM_LAYOUT: 'UI/ITEM_LAYOUT',
    UPDATE_MESSAGING_NOTIFICATIONS: 'UI/UPDATE_MESSAGING_NOTIFICATIONS'
};

const openQuickView = payload => dispatch => {
    fetch(ENDPOINTS.GET_ITEM + payload.itemId, { credentials: 'same-origin' })
        .then(response => response.json())
        .then(jsonResult => {
            if (jsonResult) {
                dispatch(itemActions.add([jsonResult]));
            }
        })
        .catch(err => {
            dispatch(closeQuickView());
            logger(err);
        });
    dispatch({
        type: actionTypes.OPEN_QUICK_VIEW,
        payload
    });
};

const closeQuickView = payload => ({
    type: actionTypes.CLOSE_QUICK_VIEW,
    payload
});

const openVideoModal = payload => ({
    type: actionTypes.OPEN_VIDEO_MODAL,
    payload
});

const closeVideoModal = payload => ({
    type: actionTypes.CLOSE_VIDEO_MODAL,
    payload
});

const openMegaMenu = payload => ({
    type: actionTypes.OPEN_MEGA_MENU,
    payload
});

const closeMegaMenu = payload => ({
    type: actionTypes.CLOSE_MEGA_MENU,
    payload
});

const openSignInModal = payload => ({
    type: actionTypes.OPEN_SIGN_IN_MODAL,
    payload
});

const closeSignInModal = payload => ({
    type: actionTypes.CLOSE_SIGN_IN_MODAL,
    payload
});

/**
 * signIn
 * @param {object} payload
 * @param {string} payload.redirectUrl - where to send the user after login completes
 */
const signIn = payload => (dispatch, getStore) => {
    const {
        initData: {
            featureSwitches: { 'login-anywhere': loginAnywhere }
        }
    } = getStore();

    if (window.innerWidth < breakPoints[BPOINT.small].max || !loginAnywhere) {
        window.location = `/login${getReturnUrl(payload.redirectUrl)}`;
    } else {
        Analytics.trackEvent({
            category: 'User',
            action: 'Navigation',
            label: `Login Anywhere - open`
        });
        dispatch(openSignInModal({ redirectUrl: payload.redirectUrl }));
    }
};

/*
    Changes made to messaging modal will affect My Tradera as well!
*/
const openMessagingModal = payload => ({
    type: actionTypes.OPEN_MESSAGING_MODAL,
    payload
});

const closeMessagingModal = payload => ({
    type: actionTypes.CLOSE_MESSAGING_MODAL,
    payload
});

const itemLayout = (name, value) => ({
    type: actionTypes.ITEM_LAYOUT,
    payload: {
        name: name,
        value: value
    }
});

const updateItemLayout = layout => dispatch => {
    dispatch(itemLayout('ITEM_LAYOUT', layout));
};

const updateMessagingNotifications = (notifications, timeFetched) => ({
    type: actionTypes.UPDATE_MESSAGING_NOTIFICATIONS,
    payload: {
        ...notifications,
        lastFetched: timeFetched
    }
});

const fetchMessagingNotifications = () => {
    return async (dispatch, getState) => {
        const state = getState();
        const { lastFetched, threadsUnread } = state.ui.badges.messaging;
        if (Date.now() - lastFetched > 60000) {
            try {
                const response = await axios.get(
                    ENDPOINTS.MESSAGING_NOTIFICATIONS,
                    {
                        withCredentials: true
                    }
                );
                const { data: notifications } = response;
                if (notifications.threadsUnread !== threadsUnread) {
                    dispatch(
                        updateMessagingNotifications(notifications, Date.now())
                    );
                }
            } catch (error) {
                // Ignore stats API error in frontend
                if (!('response' in error)) {
                    logger(error);
                }
            }
        }
    };
};

export default {
    openQuickView,
    closeQuickView,
    openVideoModal,
    closeVideoModal,
    openMegaMenu,
    closeMegaMenu,
    openSignInModal,
    closeSignInModal,
    signIn,
    openMessagingModal,
    closeMessagingModal,
    itemLayout,
    updateItemLayout,
    updateMessagingNotifications,
    fetchMessagingNotifications,
    actionTypes
};



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/state/actions/ui.js